import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import { UserProduct } from '../types/entities';
import { ExpiryStatus } from '../types/enums';
import { Page } from '../types';

/**
 * Chaves de cache do domínio "produtos". Moram no service (e não nos hooks)
 * porque as mutações abaixo precisam das mesmas chaves para invalidar.
 */
export const CHAVES_PRODUTOS = {
  dominio: ['produtos'] as const,
  /** O filtro de validade entra na chave; a página, o usePagina põe no fim. */
  lista: (userId: string, filtro: ExpiryStatus | 'ALL') => ['produtos', 'lista', userId, filtro] as const,
  contagem: (userId: string) => ['produtos', 'contagem', userId] as const,
};

const ProductService = {
  // GET /api/v1/users/{userId}/products?page=[&expiryStatus=] → Page<UserProduct>
  // 10 por página, mais recentes primeiro; o filtro de validade é resolvido no backend.
  getPage: (userId: string, page: number, expiryStatus?: ExpiryStatus): Promise<AxiosResponse<Page<UserProduct>>> =>
    api.get(`/users/${userId}/products`, { params: { page, expiryStatus } }),

  // GET /api/v1/users/{userId}/products/counts → { EXPIRED: n, EXPIRING_SOON: n, OK: n, NO_DATE: n }
  // A prateleira inteira contada por validade: os avisos de vencido/vencendo e o total.
  getCounts: (userId: string): Promise<AxiosResponse<Record<ExpiryStatus, number>>> =>
    api.get(`/users/${userId}/products/counts`),

  // POST /api/v1/users/{userId}/products
  create: (userId: string, productData: Partial<UserProduct>): Promise<AxiosResponse<UserProduct>> =>
    api.post(`/users/${userId}/products`, productData).then(invalidando(CHAVES_PRODUTOS.dominio)),

  // PUT /api/v1/users/{userId}/products/{productId}
  update: (userId: string, productId: string, productData: Partial<UserProduct>): Promise<AxiosResponse<UserProduct>> =>
    api.put(`/users/${userId}/products/${productId}`, productData).then(invalidando(CHAVES_PRODUTOS.dominio)),

  // DELETE /api/v1/users/{userId}/products/{productId}
  remove: (userId: string, productId: string): Promise<AxiosResponse<void>> =>
    api.delete(`/users/${userId}/products/${productId}`).then(invalidando(CHAVES_PRODUTOS.dominio)),
};

export default ProductService;
